import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import PlatformFeatures from './components/PlatformFeatures';
import StatsSection from './components/StatsSection';
import RankingSection from './components/RankingSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';

export default function Home() {
  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩漫漫画网站',
    url: 'http://yashisz.com/',
    description: '韩漫漫画网站致力于提供完整韩漫大全、优质推荐和流行排行榜，您可免费下拉式阅读高清内容，无广告干扰，享受纯粹阅读乐趣。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'http://yashisz.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩漫漫画网站',
    url: 'http://yashisz.com/',
    description: '韩国漫画大全，免费下拉式阅读高清韩漫',
  };

  const webPageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '韩国漫画大全_好看的韩漫推荐_韩国漫画排行榜',
    description: '韩漫漫画网站致力于提供完整韩漫大全、优质推荐和流行排行榜',
    url: 'http://yashisz.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '韩漫漫画网站',
      url: 'http://yashisz.com/',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(webPageJsonLd)}</script>

      <Navbar />
      <main>
        <HeroSection />
        <FeaturedSection />
        <PlatformFeatures />
        <StatsSection />
        <RankingSection />
        <TestimonialsSection />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}